module.exports = __webpack_public_path__ + "static/media/star-gold.bf1a75bd.svg";